import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-info-modal',
  templateUrl: './mobile-info-modal.component.html',
  styleUrls: ['./mobile-info-modal.component.scss']
})
export class MobileInfoModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
